import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbModalModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'

import { EntityListModule } from 'common/entityList'
import { UtilCommonModule } from 'common/util/module'
import { UtilReleaseNotesModule } from 'common/util.releaseNotes/module'
import { LocaleModule } from 'common/locale/module'

import { ObjectPickerModal } from './components/objectPickerModal.component'
import { ElementsPathSelectorComponent } from './components/elementsPathSelector.component'
import { OpenDialogModalComponent } from './components/openDialogModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocaleModule.forChild(),
    NgbModalModule,
    NgbDropdownModule,
    UtilCommonModule,
    UtilReleaseNotesModule,
    EntityListModule,
  ],
  declarations: [
    ElementsPathSelectorComponent,
    ObjectPickerModal,
    OpenDialogModalComponent,
  ],
  exports: [
    ElementsPathSelectorComponent,
  ],
})
export class UtilPickersModule { }

export { PickerService } from './services/picker.service'
export { PickerItem, PickerOptions } from './types'
export { OpenDialogService } from './services/openDialog.service'
